export { LastReportSection, type LastReportSectionProps } from "./LastReportSection"
